import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="App-header">
      <div className="header-container">
        <div className="logo">
          <NavLink to="/">
            <span>CABnHAUL</span>
          </NavLink>
        </div>

        <nav className="center-nav" aria-label="Main navigation">
          <button className="anchor-link" onClick={() => scrollToSection('services')}>Services</button>
          <button className="anchor-link" onClick={() => scrollToSection('testimonials')}>Testimonials</button>
          <NavLink to="/contact" className="anchor-link">Contact</NavLink>
        </nav>

        <div className="header-right">
          <a href="tel:+12153843448" className="header-phone">(215) 384-3448</a>
          <NavLink to="/contact" className="nav-button">Get a Quote</NavLink>
        </div>

        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(o => !o)}
        >
          <span /><span /><span />
        </button>
      </div>

      {menuOpen && (
        <div className="mobile-menu">
          <button className="anchor-link" onClick={() => scrollToSection('services')}>Services</button>
          <button className="anchor-link" onClick={() => scrollToSection('testimonials')}>Testimonials</button>
          <NavLink to="/contact" className="anchor-link" onClick={() => setMenuOpen(false)}>Contact</NavLink>
          <a href="tel:+12153843448" className="anchor-link header-phone-mobile">(215) 384-3448</a>
          <NavLink to="/contact" className="nav-button mobile-cta" onClick={() => setMenuOpen(false)}>Get a Quote</NavLink>
        </div>
      )}
    </header>
  );
};

export default Header;
